import * as React from 'react';
import { ListContext } from '../list/list';
class ListItemCore extends React.Component {
    get iconClassName() {
        var _a;
        return (_a = this.props.iconClassName) !== null && _a !== void 0 ? _a : this.context.iconClassName;
    }
    BEM() {
        const classArray = ['list__item'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    iconBEM(icon) {
        const classArray = ['list__icon'];
        if (icon === '#check') {
            classArray.push('list__icon--check');
        }
        if (this.iconClassName) {
            classArray.push(this.iconClassName);
        }
        return classArray.join(' ');
    }
    getIcon(icon) {
        const { Icon } = this.props.components;
        return React.createElement(Icon, { modifiers: icon, size: this.context.iconSize, className: this.iconBEM(icon), "aria-hidden": true });
    }
    render() {
        const icon = this.props.icon || this.context.icon;
        const direction = this.context.direction;
        return (React.createElement("li", { className: this.BEM() },
            React.createElement("div", { className: "list__item-inner" },
                icon && !direction && this.getIcon(icon),
                React.createElement("div", { className: "list__content" }, this.props.children))));
    }
}
ListItemCore.contextType = ListContext;
export default ListItemCore;
